/**
 * MenuSectionItem 기본 확장 상태
 */
export const DEFAULT_EXPANDED = true;

/**
 * 섹션 헤더 높이 (px)
 */
export const SECTION_HEADER_HEIGHT = 32;

/**
 * MenuSectionItem 색상 타입
 */
export const MenuSectionItemColorSet = ['default', 'global'] as const;
export type MenuSectionItemColor = (typeof MenuSectionItemColorSet)[number];
